import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/useAppDispatch'
import {
  getPaginatedNews,
  getNewsCount,
  getNewsCategories,
  getNewsTags,
} from 'actions/news.action'
import { RootState } from 'reducers/rootReducer'
import { TranslationKeys } from 'types/TranslationKeys'

export interface NewsListProps {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useNewsList = (props: NewsListProps) => {
  const { isAr } = props

  const dispatch = useAppDispatch()

  enum InitialValues {
    From = 0,
    To = 5,
  }

  const [from, setFrom] = useState(InitialValues.From)
  const [to, setTo] = useState(InitialValues.To)
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedCategory, setSelectedCategory] = useState('')
  const [selectedTag, setSelectedTag] = useState('')

  const paginatedNewsData = useSelector(
    (state: RootState) => state.news.paginatedNewsData
  )
  const newsCategories = useSelector(
    (state: RootState) => state.news.newsCategories
  )
  const newsTags = useSelector((state: RootState) => state.news.newsTags)
  const isLoading = useSelector(
    (state: RootState) => state.news.isLoadingPaginatedNews
  )
  const newsCount = useSelector((state: RootState) => state.news.newsCount)

  const handleLoadMore = () => {
    setFrom(from + 6)
    setTo(to + 6)
  }

  const handleSearch = () => {
    setFrom(InitialValues.From)
    setTo(InitialValues.To)
    dispatch(
      getPaginatedNews(
        InitialValues.From,
        InitialValues.To,
        searchTerm,
        selectedCategory,
        selectedTag,
        isAr
      )
    )
    dispatch(getNewsCount(searchTerm, selectedCategory, selectedTag, isAr))
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  useEffect(() => {
    if (!paginatedNewsData) {
      dispatch(
        getPaginatedNews(
          InitialValues.From,
          InitialValues.To,
          searchTerm,
          selectedCategory,
          selectedTag,
          isAr
        )
      )
      dispatch(getNewsCount(searchTerm, selectedCategory, selectedTag, isAr))
      dispatch(getNewsCategories())
      dispatch(getNewsTags())
    }
  }, [paginatedNewsData])

  useEffect(() => {
    if (from !== InitialValues.From) {
      dispatch(
        getPaginatedNews(
          from,
          to,
          searchTerm,
          selectedCategory,
          selectedTag,
          isAr
        )
      )
      dispatch(getNewsCount(searchTerm, selectedCategory, selectedTag, isAr))
    }
  }, [from, to])

  return {
    ...props,
    searchTerm,
    selectedCategory,
    selectedTag,
    paginatedNewsData,
    newsCount,
    newsCategories,
    newsTags,
    isLoading,
    setSearchTerm,
    setSelectedCategory,
    setSelectedTag,
    handleSearch,
    handleKeyDown,
    handleLoadMore,
  }
}
